import "./Aldar.css";

const AldarPage = () => {
  return (
    <iframe
      src="https://world.aldar.com/uae/rak/almarjan"
      className="iframe-fullscreen"
    ></iframe>
  );
};

export default AldarPage;
